// JSON for an inline <script type="application/ld+json">. JSON.stringify
// leaves "<" alone, so a voice name or collection title containing
// "</script>" closed the tag and ran whatever followed on every visit.
// "<" is the same character to a JSON parser.
export function jsonLd(value: unknown): string {
  return JSON.stringify(value).replace(/</g, "\\u003c");
}
